import type {components, paths} from '../../openapi';
import {axiosInstance} from '../axiosInstance';

export type DeclineTaskResponse = components['schemas']['Task'];
export type DeclineTaskPath = NonNullable<paths['/executor_web/tasks/{id}/decline']['patch']['parameters']['path']>;

/** PATCH `/api/executor_web/v1/executor_web/tasks/{id}/decline` — см. `paths['/executor_web/tasks/{id}/decline']` в openapi */
export function declineTask(path: DeclineTaskPath, signal?: AbortSignal) {
	return axiosInstance.patch<DeclineTaskResponse>(`tasks/${path.id}/decline`, undefined, {signal});
}
